module.exports = __webpack_public_path__ + "static/media/agent.ffc1ee69.svg";